import React, { useState } from "react";
import { separate } from "../../../../Seprate/Seprate";
import Style from "./FactureItem.module.css";
import { Button, Popover, Radio } from "antd";
import { facturePayApi } from "../../../../Api/BarestServices";
import { errorToast, succToast } from "../../../../Toast/Toast";
const FactureItem = ({ data }) => {
  const [paymentTypeState, setPaymentTypeState] = useState("pgw");
  const [loadingState, setLoadingState] = useState(false);
  
  const payFacturHandler = () => {
    setLoadingState(true);
    const info = {
      id: data.id,
      payment_type: paymentTypeState,
    };
    facturePayApi(info, (res) => {
      if (res.status === 1) {
        succToast("درخواست شما ثبت شد");
        if (paymentTypeState === "pgw") {
          window.open(res.link, "_self");
        }
        setLoadingState(false);
      } else {
        errorToast(res.message);
        setLoadingState(false);
      }
    });
  };
  const statusHandler = (status) => {
    switch (status) {
      case "1":
        return "پرداخت شده";
      case "-1":
        return "کنسل شده";
      case "0":
        return "پرداخت نشده";

      default:
        break;
    }
  };
  const paymentType = (
    <div className={Style.paymentHolder}>
      <Radio.Group
        onChange={(e) => setPaymentTypeState(e.target.value)}
        value={paymentTypeState}
        style={{
          display: "flex",
          flexDirection: "column",
          direction: "rtl",
          width: "100%",
        }}
        options={[
          { value: "wallet", label: "کیف پول" },
          { value: "pgw", label: "پرداخت آنلاین" },
        ]}
      />
      <Button
        type="primary"
        onClick={payFacturHandler}
        loading={loadingState}
        disabled={loadingState}
      >
        پرداخت
      </Button>
    </div>
  );
  return (
    <section className={Style.ItemHolder}>
      <div className={Style.FactorTopPart}>
        <div>
          <p>
            شناسه فاکتور: <span>{data?.id}</span>
          </p>
          <p>
            مبلغ فاکتور: <span>{separate(data?.amount)} تومان</span>
          </p>
        </div>
        <div>
          <p>
            وضعیت:<span>{statusHandler(data?.status)}</span>
          </p>
          {data?.status === "0" ? (
            <Popover
              overlayInnerStyle={{ direction: "rtl" }}
              destroyTooltipOnHide={true}
              content={paymentType}
              title="نوع پرداخت رو انتخاب کنید"
              trigger="click"
            >
              <button className={Style.buttonHolder}>پرداخت</button>
            </Popover>
          ) : (
            <></>
          )}
        </div>
      </div>
      {data?.description && (
        <p className={Style.FactorBottomPart}>
          توضیحات فاکتور:
          <br />
          {/* حرف n خالی هم به لیست جستجو اضافه شد */}
          {data.description.split(/\\n|\n|\/n|n/).map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </p>
      )}
    </section>
  );
};

export default FactureItem;
